var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vModal vModalDefault LocationsCustomMessageEditor" },
    [
      _c("div", { staticClass: "vModalDefaultHeader" }, [
        _vm._v(" Custom Notification Editor "),
        _c(
          "button",
          {
            staticClass: "vModalDefaultCloseButton",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          },
          [_vm._v("close")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "Body" },
        [
          _vm.loading
            ? _c("div", { staticClass: "Loader" }, [_c("RbvLoading")], 1)
            : _c("RichTextarea", {
                attrs: { init: _vm.tinyMceConfig, model: _vm.content },
                on: {
                  onChange: _vm.updateModel,
                  onUndo: _vm.updateModel,
                  onRedo: _vm.updateModel,
                },
              }),
        ],
        1
      ),
      _c("div", { staticClass: "vModalDefaultFooter" }, [
        _c(
          "button",
          {
            staticClass: "rbButton",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          },
          [_vm._v("Cancel")]
        ),
        _c(
          "button",
          {
            staticClass: "rbButton mainButton",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.save()
              },
            },
          },
          [_vm._v("Save")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }